import { FC } from "react";
import { Trans, useTranslation } from "react-i18next";

export interface BrandTranslationProps {
  brand: string | undefined | null;
  fallback?: "all" | "none" | "unknown";
}

export const BrandTranslation: FC<BrandTranslationProps> = ({ brand, fallback }) => {
  useTranslation("common");

  return <Trans ns="common" i18nKey={`brands.${brand ?? fallback ?? "unknown"}`}/>;
};
